export class AuthExpiredError extends Error {
  constructor(message = 'HTTP 401: Authentication expired') {
    super(message)
    this.name = 'AuthExpiredError'
  }
}

/**
 * Performs a fetch with Authorization header from localStorage token.
 */
export async function authFetch(url, options = {}) {
  const originalHeaders = options.headers || {}
  const headers = new Headers(originalHeaders)

  // Attach bearer token if not already present
  if (!headers.has('Authorization')) {
    const token = localStorage.getItem('token')
    if (!token) {
      throw new Error('Authentication token not available')
    }
    headers.set('Authorization', `Bearer ${token}`)
  }

  const finalOptions = { ...options, headers }
  const response = await fetch(url, finalOptions)

  if (response.status === 401) {
    // Try a single refresh + retry
    if (typeof window !== 'undefined' && window.refreshAuthToken) {
      try {
        await window.refreshAuthToken()
        const newToken = localStorage.getItem('token')
        if (newToken) {
          const retryHeaders = new Headers(headers)
          retryHeaders.set('Authorization', `Bearer ${newToken}`)
          const retryResponse = await fetch(url, {
            ...finalOptions,
            headers: retryHeaders
          })
          if (retryResponse.ok) {
            return retryResponse
          }
          // If retry produced a non-401 error, return it to caller to handle
          if (retryResponse.status !== 401) {
            return retryResponse
          }
        }
      } catch (refreshError) {
        console.warn(
          'Token refresh failed, proceeding with logout:',
          refreshError
        )
      }
    }

    // Logout on persistent 401
    try {
      localStorage.removeItem('token')
      localStorage.removeItem('username')
    } catch {}
    if (typeof window !== 'undefined' && window.dispatchLogout) {
      try {
        window.dispatchLogout()
      } catch {}
    }
    throw new AuthExpiredError()
  }

  return response
}
